'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCamera, iconCameraTag } from '@ni/nimble-components/dist/esm/icons/camera';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCamera };
export { iconCameraTag };
export const NimbleIconCamera = wrap(IconCamera);